import Validation from '_shared/validation/validation'

const validation = new Validation()
export default validation

// Any SBSA specific validators can be imported here,
// and then passed into the Validation constructor
